import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Component, EventEmitter, Inject, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-cv-map',
  templateUrl: './cv-map.component.html',
  styleUrls: ['./cv-map.component.scss']
})
export class CvMapComponent implements OnInit {
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild("addresstext", { static: false }) addresstext: any;

  private searchUpdated: Subject<CvMapComponent> = new Subject();
  autocompleteInput: string;
  queryWait: boolean;

  zoom = 18;
  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    zoom: 18,
    scrollwheel: true,
    gestureHandling: "cooperative",
    disableDoubleClickZoom: true,
    mapTypeId: "roadmap",
    mapTypeControl: true,
    streetViewControl: false,
    fullscreenControl: false,
    minZoom: 1,
    maxZoom: 1000,
    zoomControl: true,
  };

  google_search: string;
  search_box;
  markers = [];
  infoContent;
  marker: MapMarker;
  latitude: number;
  longitude: number;
  process_bar: number = 0;
  address: string;
  interval;
  timer: number = 3;
  geo_decoder = new google.maps.Geocoder();
  show_map = 1;
  loading = false;
  pinterval: any;
  selected_options: any;
  multiple: any;
  current_option;

  form_group: UntypedFormGroup = new UntypedFormGroup({
    locationDesc: new UntypedFormControl(null)
  });
  form_control
  label
  placeholder
  enable_description

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngZone: NgZone,
    private matDailogRef: MatDialogRef<CvMapComponent>,
  ) {
    navigator.geolocation.getCurrentPosition((position) => {
      if (
        this.data &&
        this.data.latitude &&
        this.data.longitude &&
        this.data.latitude != NaN &&
        this.data.longitude != NaN
      ) {

        this.center = {
          lat: parseFloat(this.data.latitude),
          lng: parseFloat(this.data.longitude),
        };
      } else {
        this.getCurrentLocation();
      }
    });
    this.addMarker(this.data.latitude, this.data.longitude);
  }
  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }
  ngOnChanges() {
    // this.ngAfterViewInit();
  }
  ngOnInit() {
    navigator.permissions
      .query({
        name: "geolocation",
      })
      .then((res) => {

        if (res["state"] == "granted") {
        } else if (res["state"] == "denied") {
          navigator.geolocation.getCurrentPosition((res) => { });
        } else {
          navigator.geolocation.getCurrentPosition((res) => { });
        }
      });
    //    legend.appendChild(div)
    //  this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(legend);
    this.show_map = 1;

    if (this.data && this.data.options) {
      this.selected_options = this.data.options;
    }
    if (this.data && this.data.multiple) {
      this.multiple = this.data.multiple;
    }

    if (this.data) {
      this.enable_description = this.data.enable_description;
      this.label = this.data.label;
      this.placeholder = this.data.placeholder;
      this.form_group.controls.locationDesc.patchValue(this.data.description)
    }
  }
  setTimer() {
    this.show_map = 0;
    if (this.show_map != 1) {
      this.startTimer();
    }
    if (this.interval) {
      clearTimeout(this.interval);
    }
    this.interval = setTimeout(() => {
      // this.getPlaceByAddress();
    }, 3000);

    //   for(let i =0; i< 80 ;i++){
    //     this.process_bar++;
    // //   waits(1000)
    //   }
  }
  setCurrentCity(city) {
    console.log(city)
    this.current_option = city;
    this.addMarker(this.current_option.latitude, this.current_option.longitude);
  }
  startTimer() {
    this.pinterval = setInterval(() => {
      if (this.process_bar < 90) {
        this.process_bar += 1;
      } else {
        this.process_bar = 0;
      }
    }, 1000);
  }
  pauseTimer() {
    clearInterval(this.pinterval);
  }

  getPlaceByAddress() {
    this.timer = 10;
    const service = new google.maps.places.PlacesService(
      this.addresstext.nativeElement
    ).findPlaceFromQuery(
      {
        query: this.google_search,
        fields: ["name", "geometry", "formatted_address"],
      },
      (res) => {
        // 
        this.pauseTimer();
        this.process_bar = 0;
        if (res && res[0]) {

          this.data.address = res[0].formatted_address;
          this.zoom = 20;
          this.addMarker(
            res[0].geometry.location.lat(),
            res[0].geometry.location.lng()
          );
          // this.center= {
          //   lat :res[0].geometry.location.lat(),
          //   lng:res[0].geometry.location.lng(),
          // }
          // this.data.latitude = res[0].geometry.location.lat();
          // this.data.longitude= res[0].geometry.location.lng();
        } else {
        }
      }
    );
    // let timer = setTimeout(()=>{
    //   this.process_bar +=5;
    // },1000);
  }
  getCurrentLocation() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      this.addMarker(position.coords.latitude, position.coords.longitude);
    });
  }
  /************ FOR AUTOCOMPLETE FEATURE  **************** */
  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.addresstext.nativeElement,
      {}
    );
    types: ["address"]; // 'establishment' / 'address' / 'geocode'
    // google.maps.event.addListener()
    google.maps.event.addListener(autocomplete, "place_changed", () => {
      const address = String(autocomplete.getPlace().formatted_address);

      if (autocomplete.getPlace().geometry) {
        this.data.latitude = autocomplete.getPlace().geometry.location.lat();
        this.data.longitude = autocomplete.getPlace().geometry.location.lng();
        this.addMarker(this.data.latitude, this.data.longitude);
        if (
          this.data.latitude &&
          this.data.longitude &&
          this.data.latitude != NaN &&
          this.data.longitude != NaN
        ) {
          this.center = {
            lat: parseFloat(this.data.latitude),
            lng: parseFloat(this.data.longitude),
          };
        }
      } else {
        this.getPlaceByAddress();
      }
      this.invokeEvent(address);
    });
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }

  click(event: google.maps.MouseEvent) {
    this.data.latitude = event.latLng.lat();
    this.data.longitude = event.latLng.lng();

    this.addMarker(event.latLng.lat(), event.latLng.lng());
  }

  logCenter() {
  }

  addMarker(latitude, longitude) {

    this.markers = [];
    this.markers.push({
      position: {
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      },
      label: {
        // color: 'red',
        // text: '.',
      },
      options: {
        icon: "assets/Location_pin_1.png",
        draggable: true,
        animation: window["google"].maps.Animation.DROP,
        // animation: google.maps.Animation.BOUNCE,
      },
      zoom: this.zoom,
    });
    this.center = {
      lat: latitude,
      lng: longitude,
    };
    this.data.latitude = latitude;
    this.data.longitude = longitude;
    this.show_map = 1;
    if (this.multiple) {
      if (this.current_option) {
        this.current_option['latitude'] = latitude;
        this.current_option['longitude'] = longitude;
      }
    }
  }

  openInfo(marker: MapMarker, content) {
    this.marker = marker;
    this.infoContent = content;
    this.info.open(marker);
  }

  close() {
    if (this.enable_description) {
      this.data['locationDesc'] = this.form_group.value.locationDesc;
    }
    this.matDailogRef.close(this.data);
  }
  close1() {
    this.matDailogRef.close();
  }
}
